import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=48c8301f&"
import script from "./ProductTable.vue?vue&type=script&lang=ts&"
export * from "./ProductTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports